import { push as pushRoute, replace as replaceRoute } from "react-router-redux";

import { st, ProductsRepository } from "lib/index";
import { createResourceInstance } from "modules/utils/index";

export const INITIALIZE_APP = "app/INITIALIZE_APP";
export const FETCH_APP = "app/FETCH_APP";
export const FETCH_APP_START = "app/FETCH_APP_START";
export const FETCH_APP_SUCCESS = "app/FETCH_APP_SUCCESS";
export const FETCH_APP_FAILURE = "app/FETCH_APP_FAILURE";
export const SET_APP_ERROR = "app/SET_APP_ERROR";
export const CREATE_ALERT = "app/CREATE_ALERT";
export const REMOVE_ALERT = "app/REMOVE_ALERT";
export const TOGGLE_LEFT_BAR = "app/TOGGLE_LEFT_BAR";
export const TOGGLE_SIDEBAR = "app/TOGGLE_SIDEBAR";
export const FORCE_LEFT_BAR_TOGGLE = "app/FORCE_LEFT_BAR_TOGGLE";
export const SET_LOCATION = "app/SET_LOCATION";

export function initializeApp({ reset = true } = {}) {
  return { type: INITIALIZE_APP, reset };
}

export function fetchApp() {
  return { type: FETCH_APP };
}

export function setAppError({ error } = {}) {
  return { type: SET_APP_ERROR, error };
}

// Alerts dismiss themselves after `timeout` ms; `false` keeps one up until the operator closes
// it, the way failed requests do. The default has to cover reading a full sentence and noticing
// it in the first place - three seconds was gone before an alert fired mid-scroll was read.
export function createAlert({ uuid = st.generateUuid(), type = "info", content, timeout = 8000 }) {
  const alert = { uuid, type, content, timeout };
  if (!["info", "error", "success", "warning"].includes(type)) {
    throw `Unknown alert.type: ${type}`;
  }
  return { type: CREATE_ALERT, alert };
}

export function removeAlert({ uuid }) {
  return { type: REMOVE_ALERT, alert: { uuid } };
}

export function toggleLeftBar(toggle, { persist = true } = {}) {
  return { type: TOGGLE_LEFT_BAR, toggle, persist };
}

export function toggleSidebar() {
  return { type: TOGGLE_SIDEBAR };
}

export function forceLeftBarToggle(force) {
  return { type: FORCE_LEFT_BAR_TOGGLE, force };
}

export function setLocation(location) {
  return {
    type: SET_LOCATION,
    location: {
      pathname: location.pathname,
      // search: location.search,
      query: location.query,
      state: location.state,
      // hash: location.hash,
    },
  };
}

export { pushRoute, replaceRoute };

function convertRouteToCompanyRoute(route, getState) {
  const currentCompanyId = getState().auth.company.model.id;
  const path = typeof route === "string" ? route : route.pathname;
  const nextPath = currentCompanyId ? `/c/${currentCompanyId}${path}` : path;
  const nextRoute = typeof route === "string" ? nextPath : { ...route, pathname: nextPath };
  return nextRoute;
}

export function pushCompanyRoute(route, replace = false) {
  return (dispatch, getState) => {
    const nextRoute = convertRouteToCompanyRoute(route, getState);
    dispatch(replace ? replaceRoute(nextRoute) : pushRoute(nextRoute));
  };
}

export function replaceCompanyRoute(route) {
  return pushCompanyRoute(route, true);
}

export function render403() {
  return (dispatch, getState) => {
    const currentPath = getState().app.location.pathname;
    dispatch(pushCompanyRoute(`/403?next=${encodeURIComponent(currentPath)}`));
  };
}

export function render404() {
  return (dispatch, getState) => {
    const currentPath = getState().app.location.pathname;
    dispatch(pushCompanyRoute(`/404?next=${encodeURIComponent(currentPath)}`));
  };
}



// WEBPACK FOOTER //
// ./src/modules/app/actions.js